import React, { Component } from 'react';
import { Map, List } from 'immutable';
import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { setViewstate } from '../actions/actionCreators';
import connect from '../store/connect';
import FiltersList from '../components/FiltersList';
import SortingList from '../components/SortingList';
import { Container } from '../styles/Container';
import { color } from '../styles/helpers/variables';
import { fontFamilyBody } from '../styles/helpers/mixins';

class Filters extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeFilterOption: null
    };
  }

  setSortBy(key, ascending) {
    this.props.setViewstate('sortBy', key);
    this.props.setViewstate('sortAscending', ascending);
  }

  setFilterBy(key, value) {
    if (this.props.viewstate.get(`filter/${key}`) && this.props.viewstate.get(`filter/${key}`).includes(value)) {
      const filterParamIndex = this.props.viewstate.get(`filter/${key}`).indexOf(value);
      this.props.setViewstate(`filter/${key}`, this.props.viewstate.get(`filter/${key}`).delete(filterParamIndex));
    } else if (this.props.viewstate.get(`filter/${key}`)) {
      this.props.setViewstate(`filter/${key}`, this.props.viewstate.get(`filter/${key}`).push(value));
    } else {
      this.props.setViewstate(`filter/${key}`, List([value]));
    }
  }

  activateFilterOptionMenu(id) {
    if (this.state.activeFilterOption === id) {
      this.setState({ activeFilterOption: null });
    } else {
      this.setState({ activeFilterOption: id });
    }
  }

  renderFilterOptions() {
    const { includeCategoryFilter } = this.props;

    let filterList;

    if (includeCategoryFilter) {
      filterList = [
        { name: 'Underkategori', id: 'category', selector: ['category', 'name'] },
        { name: 'Varumärke', id: 'manufacturer', selector: ['brand', 'name'] },
        { name: 'Färg', id: 'color', selector: ['variants', 0, 'filterColor'] }
      ];
    } else {
      filterList = [
        { name: 'Varumärke', id: 'manufacturer', selector: ['brand', 'name'] },
        { name: 'Färg', id: 'color', selector: ['variants', 0, 'filterColor'] }
      ];
    }

    return filterList.map((item, index) => {
      const realIndex = index + 1;
      return (
        <FilterOptionContainer key={realIndex} isActive={this.state.activeFilterOption === realIndex}>
          <FilterToggleButton
            isActive={this.state.activeFilterOption === realIndex}
            onClick={() => this.activateFilterOptionMenu(realIndex)}
          >
            {item.name}
            {this.props.viewstate.getIn(['filter', item.id], List()).size ? (
              <span>({this.props.viewstate.getIn(['filter', item.id], List()).size})</span>
            ) : (
              false
            )}
          </FilterToggleButton>
          {this.state.activeFilterOption === realIndex && (
            <FilterOptionMenu>
              <FiltersList
                products={this.props.products}
                type={item.id}
                selector={item.selector}
                forColor={item.id === 'color'}
              />
            </FilterOptionMenu>
          )}
        </FilterOptionContainer>
      );
    });
  }

  render() {
    const filterOptions = this.renderFilterOptions();

    let sortingString = '';

    if (this.props.viewstate.get('sortBy') === 'relevance' && this.props.viewstate.get('sortAscending'))
      sortingString = 'sökrelevans';
    else if (this.props.viewstate.get('sortBy') === 'name' && !this.props.viewstate.get('sortAscending'))
      sortingString = 'namn (A-Ö)';
    else if (this.props.viewstate.get('sortBy') === 'name' && this.props.viewstate.get('sortAscending'))
      sortingString = 'namn (Ö-A)';
    else if (this.props.viewstate.get('sortBy') === 'price' && !this.props.viewstate.get('sortAscending'))
      sortingString = 'pris lågt till högt';
    else if (this.props.viewstate.get('sortBy') === 'price' && this.props.viewstate.get('sortAscending'))
      sortingString = 'pris högt till lågt';
    else if (this.props.viewstate.get('sortBy') === 'addedDate' && this.props.viewstate.get('sortAscending'))
      sortingString = 'senast inkommet';

    return (
      <Container noPadding mb={15}>
        <Overlay active={this.state.activeFilterOption} onClick={() => this.setState({ activeFilterOption: null })} />
        <FilterContainer>
          {filterOptions}
          <FilterOptionContainer isActive={this.state.activeFilterOption === 'sort'}>
            <SortToggleButton
              onClick={() => this.activateFilterOptionMenu('sort')}
              isActive={this.state.activeFilterOption === 'sort'}
            >
              <SortByTitle>Sortera på:</SortByTitle> {sortingString}
            </SortToggleButton>
            {this.state.activeFilterOption === 'sort' && (
              <FilterOptionMenu>
                <SortingList includeRelevance={this.props.includeRelevance} />
              </FilterOptionMenu>
            )}
          </FilterOptionContainer>
        </FilterContainer>
      </Container>
    );
  }
}

const Overlay = styled.div`
  background-color: ${color.black};
  opacity: 0.1;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  display: none;

  ${props =>
    props.active &&
    css`
      display: block;
    `};
`;

const SortByTitle = styled.span`
  font-weight: 600;
  font-style: normal;
  color: ${color.black}!important;
  margin-right: 0.25em;
`;

const FilterContainer = styled.ul`
  display: flex;
  justify-content: center;
  align-items: stretch;
  padding: 0;
  margin: 0;
  border-top: 1px solid ${color.blackTransparent};
  border-bottom: 1px solid ${color.blackTransparent};
  list-style: none;
  position: relative;
`;

const FilterOptionContainer = styled.li`
  z-index: 20;

  ${props =>
    props.isActive &&
    css`
      background-color: ${color.white};
    `};
`;

const FilterToggleButton = styled.button`
  ${fontFamilyBody};
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 2px;
  text-align: center;
  color: ${color.black};
  text-transform: uppercase;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 1rem 2rem;
  border: none;
  background-color: transparent;
  outline: 0;
  position: relative;
  bottom: -2px;
  z-index: 30;

  ${props =>
    props.isActive &&
    css`
      background-color: ${color.white};
    `};

  &:after {
    content: '';
    background-image: url('/images/icons/arrow.svg');
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 12px;
    height: 12px;
    display: inline-block;
    margin-left: 5px;
    transition: transform 0.25s ease-out;

    ${props =>
      props.isActive &&
      css`
        transform: rotateX(180deg);
      `};
  }

  span {
    color: ${color.success};
  }
`;

const SortToggleButton = styled.button`
  ${fontFamilyBody};
  font-size: 14px;
  font-weight: normal;
  letter-spacing: normal;
  text-align: center;
  font-style: italic;
  color: ${color.black};
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 1rem 2rem;
  border: none;
  background-color: transparent;
  outline: 0;
  position: relative;
  bottom: -1px;
  z-index: 30;

  ${props =>
    props.isActive &&
    css`
      background-color: ${color.white};
    `};

  &:after {
    content: '';
    background-image: url('/images/icons/arrow.svg');
    background-size: contain;
    background-repeat: no-repeat;
    min-width: 12px;
    height: 12px;
    display: inline-block;
    margin-left: 8px;
    transition: transform 0.25s ease-out;

    ${props =>
      props.isActive &&
      css`
        transform: rotateX(180deg);
      `};
  }

  span {
    color: ${color.success};
  }
`;

const FilterOptionMenu = styled.ul`
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 20;
  padding: 1rem 2rem;
  cursor: default;
  background-color: ${color.white};
  border: solid 1px ${color.grey};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

Filters.defaultProps = {
  includeCategoryFilter: false,
  viewstate: Map(),
  products: Map(),
  includeRelevance: false
};

Filters.propTypes = {
  includeCategoryFilter: PropTypes.bool,
  setViewstate: PropTypes.func.isRequired,
  viewstate: PropTypes.instanceOf(Map),
  products: PropTypes.instanceOf(Map),
  includeRelevance: PropTypes.bool
};

export default connect(
  Filters,
  { setViewstate },
  store => ({
    viewstate: store.viewstate
  })
);



// WEBPACK FOOTER //
// ./src/components/Filters.js